<template>
  <div
    class="info-primaire-promo"
    :class="content.theme"
    :style="{ 'background-color': content.couleur }"
  >
    <div class="padding-section mw-100 col-xxl-12" :class="{ 'h-100': !jel_isCarteLarge(content) }">
      <div class="texte-promo">
        <div class="sur-titre-promo" v-html="content.surTitre" />
        <div class="titre-promo" v-html="content.titre" />
        <div v-show="content.texte" class="description-promo" v-html="content.texte" />
      </div>
      <Hyperlien :content="contentBouton"></Hyperlien>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Hyperlien from '@/components/base/Hyperlien';

export default {
  name: 'CarteInfoPrimairePromo',
  components: { Hyperlien },
  props: {
    content: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      getCollectionTitreByUuid: 'produitCollection/getTitreByUuid',
    }),
    contentBouton() {
      return {
        texte: this.content.libBouton,
        type: 'boutonSecondaire',
        lien: this.content.lien,
        classeCSS: 'm-0 p-0',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.sur-titre-promo {
  font-family: $font-graphik-semibold;
}

.titre-promo {
  font-family: $font-graphik-super;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.texte-promo {
  height: 65%;
}
.description-promo {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.info-primaire-promo-5x7 {
  .titre-promo {
    -webkit-line-clamp: 2;
  }
}
</style>
